import { IMPLEMENTATION_GUIDE_API_BASE_URL } from "@/components/ImplementationGuide/constants";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";
import { CompletionRateData } from "../../types";

const useImplementationGuideCompletionRateGet = (districtUniqueId: string) => {
  const fullImplementationGuideApiUrl = `${MONOLITH_ORIGIN}${IMPLEMENTATION_GUIDE_API_BASE_URL}${districtUniqueId}/completion-rate/`;

  return useRestQuery<CompletionRateData>(fullImplementationGuideApiUrl, {
    skip: !districtUniqueId,
  });
};

export default useImplementationGuideCompletionRateGet;
